















import Component, { mixins } from 'vue-class-component';
import MessageMixin from '@/components/message-mixin';
import Message from '@/components/message.vue';

import * as Logger from 'js-logger';
import { ISoftware } from '@/models/software';
import SoftwareEdit from '@/components/software/software-edit.vue';

const log = Logger.get('software/main');

@Component(
  {
    components: { Message, SoftwareEdit }
  }
)
export default class Software extends mixins(MessageMixin) {
  softwares: ISoftware[] = []

  async mounted() {
    try {
      this.setMessage('pending', 'One sec, fetching software prices...');
      this.softwares = await this.$api.get('/api/software') as ISoftware[];
      this.message = null;
    } catch (e) {
      this.setMessage('error', `Error fetching prices`);
      log.error('Error fetching sysvars', e);
    }
  }

  rowClass(i: number, software: ISoftware) {
    if (parseFloat(software.price) === 0) {
      return 'light-green';
    }

    return (i % 2 === 0) ? 'light-grey' : '';
  }

  onSoftwareUpdated(software: ISoftware) {
    const updatedSoftware = this.softwares.find((value: ISoftware) => software.id === value.id)
    updatedSoftware!.price = software.price;
  }
}
